module.exports = __webpack_public_path__ + "img/Group 848.c3cb18dc.png";